import {
  Heading,
  Icon,
  Image,
  Jumbotron,
  LinkWithButtonStyles,
} from '@frontendmentorio/design-system-v2';

export default function Hero() {
  return (
    <Jumbotron
      className="overflow-hidden px-5 py-6 tablet:py-8"
      tagName="section"
    >
      <div className="container-xl flex flex-col gap-6 tablet:flex-row tablet:pt-4">
        <div className="flex flex-col gap-5 items-start justify-start tablet:max-w-[38rem] tablet:min-w-[30rem] tablet:pt-5 tablet:w-[65%]">
          <Heading className="leading-tight" level="1">
            Fast-track your developer career with{' '}
            <span className="bg-blue-500 font-bold px-3 rounded-lg text-white uppercase">
              Pro
            </span>
          </Heading>

          <ul className="flex flex-wrap gap-x-5 gap-y-2 justify-start max-w-[40rem]">
            <li className="flex gap-2 items-center">
              <Icon className="text-emerald-400" name="check" style="solid" />
              Get AI-powered feedback on every solution
            </li>

            <li className="flex gap-2 items-center">
              <Icon className="text-emerald-400" name="check" style="solid" />
              Choose from 50+ portfolio-ready premium projects
            </li>

            <li className="flex gap-2 items-center">
              <Icon className="text-emerald-400" name="check" style="solid" />
              Access professional Figma design files
            </li>
          </ul>

          <LinkWithButtonStyles href="#plans">
            Already sold? Unlock Pro now
          </LinkWithButtonStyles>
        </div>

        <Image
          alt="Design mockup with components and color scheme, and a code editor."
          className="object-cover object-left rounded-2xl tablet:max-w-[50%]"
          height={908}
          priority
          quality={100}
          src="/static/images/pro-hero.webp"
          width={1200}
        />
      </div>
    </Jumbotron>
  );
}
